import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoutes } from '../../shared/const'
import { mayOpenAdminPage } from '../../shared/alumni'

import ConceptReport from '../../components/views/admin/ConceptReport'

/**
 * Auswertung zum Skills4Retail-Konzept — nur für die Administration.
 *
 * Die Ansicht führt personenbezogene Daten (Alter, Geschlecht) und ist
 * deshalb keine Stelle für eine großzügige Rollenregel. Ein Landesadmin sieht
 * nur das eigene Bundesland; das grenzt das Backend ein.
 */
function ConceptReportPage(props) {
	if (mayOpenAdminPage(props.role, 'conceptReport')) return <ConceptReport />

	return <Redirect to={TRoutes.DASHBOARD} />
}

ConceptReportPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(ConceptReportPage)
